import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PaginationOptions } from '../models/tipologiche/pagination-options';

@Component({
    selector: 'paginator',
    templateUrl: 'paginator.html'
})

export class PaginatorComponent implements OnInit, OnChanges, DoCheck {
    @Input() items: number;
    @Input() options: PaginationOptions;
    @Output() onReturn: EventEmitter<number> = new EventEmitter<number>();

    pages: number[] = [];
    numPages: number;
    showLeftEllipsis: boolean;
    showRigthEllipsis: boolean;

    private currentPage: number;
    private itemsPerPage: number;
    private maxInline: number;
    private showEllipsis: boolean;

    private buildPaginator(){
        if(isNaN(this.items) || isNaN(this.currentPage) || isNaN(this.itemsPerPage) || isNaN(this.maxInline))
            return;

        this.numPages = Math.ceil(this.items / this.itemsPerPage);

        if(this.currentPage > this.numPages)
            this.onReturn.emit(this.numPages);

        this.showLeftEllipsis = this.showEllipsis && this.currentPage > this.maxInline - 2;
        this.showRigthEllipsis = this.showEllipsis && this.numPages > this.maxInline + 2 && this.currentPage < this.numPages - 4;

        let pages = [];
        let first = this.showLeftEllipsis ? this.currentPage - 2 : 1;
        let last = this.showRigthEllipsis ? Math.max(this.maxInline - 2, this.currentPage + 2) : this.numPages;

        for(let i = first; i <= last; i++) pages.push(i);

        this.pages = pages;
    }

    get da(){
        return (this.options.getCurrentPage() - 1) * this.options.getItemsPerPage() + 1;
    }

    get a(){
        if(this.items)
        return Math.min((this.options.getCurrentPage() - 1) * this.options.getItemsPerPage() + this.options.getItemsPerPage(), this.items);
        else return '1'
    }

    ngOnInit(){
        this.currentPage = this.options.getCurrentPage();
        this.itemsPerPage = this.options.getItemsPerPage();
        this.maxInline = this.options.getMaxInline();
        this.showEllipsis = this.options.ellipsisEnabled();
        this.buildPaginator();
    }

    ngOnChanges(){
        this.buildPaginator();
    }

    ngDoCheck(){
        if(this.currentPage !== this.options.getCurrentPage()){
            this.currentPage = this.options.getCurrentPage();
            this.buildPaginator();
        }
        if(this.itemsPerPage !== this.options.getItemsPerPage()){
            this.itemsPerPage = this.options.getItemsPerPage();
            this.buildPaginator();
        }
        if(this.maxInline !== this.options.getMaxInline()){
            this.maxInline = this.options.getMaxInline();
            this.buildPaginator();
        }
        if(this.showEllipsis !== this.options.ellipsisEnabled()){
            this.showEllipsis = this.options.ellipsisEnabled();
            this.buildPaginator();
        }
    }

    setPage(page){
        page = page > this.numPages ? this.numPages : page < 1 ? 1 : page;
        page !== this.currentPage && this.onReturn.emit(page);
    }

}
